<template>
  <div class="w-100 h-100 d-flex flex-column position-relative" ref="ScrollRef" style="overflow-y: scroll;">
    <div v-if="!isShareCode">
      <div class="row my-2">
        <div class="col">
          <div class="menu-tab-text menu-select-color">データ入稿</div>
        </div>
      </div>

      <div class="row p-2 position-relative" :class="{'feature-ui':this.$store.state.tutorial.isShowPreview && this.$store.state.tutorial.previewStep == 1}">
        <div class="row text-start m-0">
          <p class="m-0 p-0">デザイン（PNG）<img src="@/assets/acrypro/question-icon.svg" style="width:20px;height:20px;margin-left:-5px;margin-top:-5px;" class="cursor-pointer" @click="clickPngHelp()" /></p>
        </div>
        <label class="uploadlabel position-relative"
          ><input
            type="file"
            ref="design"
            accept=".png"
            @change="uploadDesign"
          />
          <div v-if="!isUploadDesign">
            <svg class="fill-color" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
            <path d="M22.4167 13.0002C22.4167 7.52565 17.9836 3.0835 12.5104 3.0835C7.02583 3.0835 2.58335 7.52663 2.58335 13.0002C2.58335 18.4737 7.02584 22.9168 12.5104 22.9168C17.9836 22.9168 22.4167 18.4747 22.4167 13.0002ZM21.3334 13.0002C21.3334 17.8805 17.3803 21.8335 12.5 21.8335C7.61971 21.8335 3.66669 17.8805 3.66669 13.0002C3.66669 8.11986 7.61971 4.16683 12.5 4.16683C17.3803 4.16683 21.3334 8.11985 21.3334 13.0002Z"/>
            <path d="M7.5 13.8332L17.5 13.8332L17.5 12.1665L7.5 12.1665L7.5 13.8332Z"/>
            <path d="M13.3334 18L13.3334 8L11.6667 8L11.6667 18L13.3334 18Z"/>
            </svg>
            <span class="fw-bold">アップロード</span>
          </div>
          <div v-else>
            <span class="text-main-color">{{this.getDesignFileName()}}</span>
          </div>
        </label>
      </div>

      <div class="row p-2 position-relative" :class="{'feature-ui':this.$store.state.tutorial.isShowPreview && this.$store.state.tutorial.previewStep == 2}">
        <div class="row text-start m-0">
          <p class="m-0 p-0">カットライン（SVG）<img src="@/assets/acrypro/question-icon.svg" style="width:20px;height:20px;margin-left:-5px;margin-top:-5px;" class="cursor-pointer" @click="clickSvgHelp()" /></p>
        </div>
        <label class="uploadlabel position-relative"
          ><input
            type="file"
            ref="cutline"
            accept=".svg"
            @change="uploadCutline"
          />
          <div v-if="!isUploadCutline">
            <svg class="fill-color" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
            <path d="M22.4167 13.0002C22.4167 7.52565 17.9836 3.0835 12.5104 3.0835C7.02583 3.0835 2.58335 7.52663 2.58335 13.0002C2.58335 18.4737 7.02584 22.9168 12.5104 22.9168C17.9836 22.9168 22.4167 18.4747 22.4167 13.0002ZM21.3334 13.0002C21.3334 17.8805 17.3803 21.8335 12.5 21.8335C7.61971 21.8335 3.66669 17.8805 3.66669 13.0002C3.66669 8.11986 7.61971 4.16683 12.5 4.16683C17.3803 4.16683 21.3334 8.11985 21.3334 13.0002Z"/>
            <path d="M7.5 13.8332L17.5 13.8332L17.5 12.1665L7.5 12.1665L7.5 13.8332Z"/>
            <path d="M13.3334 18L13.3334 8L11.6667 8L11.6667 18L13.3334 18Z"/>
            </svg>
            <span class="fw-bold">アップロード</span>
          </div>
          <div v-else>
            <span class="text-main-color">{{this.getCutlineFileName()}}</span>
          </div>
        </label>
      </div>

      <hr class="mt-1 mb-0">
    </div>

    <div class="row my-1">
      <div class="col m-0">
        <div class="menu-tab-text menu-select-color m-0">初回無料価格（送料込み）</div>
      </div>
    </div>

    <!-- 境界線 -->
    <p class="fw-bold m-1 text-end mb-0" style="">{{totalPrice}}円</p>
    <hr class="m-0">

    <div class="row my-1">
      <div class="col m-0">
        <div class="menu-tab-text menu-select-color m-0">数量（複数購入不可）</div>
      </div>
    </div>

    <div class="m-1 mb-1 text-end d-flex justify-content-end" style="">
      <span class="fw-bold">{{acrylNum}}</span>
      <!-- <input type="number" min="1" max="1" v-model="acrylNum" @blur="numBlur" class="forminput text-end no-spin pe-2" /> -->
    </div>
    <hr class="m-0">

    <span class="mt-1">配送先選択</span>

    <div class="row m-0 mb-3">
      <div class="col text-start">
        <p class="my-0 fw-bold mt-2">配送先</p>
        <select
          class="form-select"
          name="destination_list"
          id="destination_list"
          v-model="selectedDestination"
        >
          <option disabled value="default">選択してください</option>
          <option
            v-for="(d, index) in this.destinationList"
            v-bind:key="index"
            v-bind:value="index"
          >
            <small>配送先{{ index }}: 〒{{ d.zip01 }}-{{ d.zip02 }}</small>
          </option>
        </select>
        <button
          @click="onClickEditDestination"
          class="acry-btn-secondary-normal btn-size mt-3 mx-auto d-block" style=""
        >
          配送先を編集・追加
        </button>
        <template v-if="this.destinationList[this.selectedDestination]">
          <p class="my-0 mt-2 small">会社名</p>
          <p class="text-end my-0 p-0 small">
            {{ this.destinationList[this.selectedDestination].company_name }}
          </p>
          <hr class="my-0" />
          <p class="my-0 small">部署名</p>
          <p class="text-end my-0 p-0 small">
            {{ this.destinationList[this.selectedDestination].department_name }}&nbsp;
          </p>
          <hr class="my-0" />
          <p class="my-0 small">氏名</p>
          <p class="text-end my-0 p-0 small">
            {{ this.destinationList[this.selectedDestination].name01 }}
            {{ this.destinationList[this.selectedDestination].name02 }}
          </p>
          <hr class="my-0" />
          <p class="my-0 small">電話番号</p>
          <p class="text-end my-0 p-0 small">
            {{ this.destinationList[this.selectedDestination].tel01 }}-{{
              this.destinationList[this.selectedDestination].tel02
            }}-{{ this.destinationList[this.selectedDestination].tel03 }}
          </p>
          <hr class="my-0" />
          <p class="my-0 small">住所</p>
          <p class="text-end my-0 p-0 small">
            〒{{ this.destinationList[this.selectedDestination].zip01 }}-{{
              this.destinationList[this.selectedDestination].zip02
            }}
          </p>
          <p class="text-end my-0 p-0 small">
            {{ this.destinationList[this.selectedDestination].addr01 }}
          </p>
          <p class="text-end my-0 p-0 small">
            {{ this.destinationList[this.selectedDestination].addr02 }}
          </p>
          <hr class="mt-0" />
        </template>
      </div>
    </div>

    <div class="mt-auto w-100 my-3 position-relative" :class="{'disable-ui':!(isUploadDesign&&isUploadCutline) && !this.$store.state.tutorial.isShowPreview}">
      <div>
        <button @click="onClickOrder" class="acry-btn-cartin btn-size my-1" >注文する</button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetCanvasSize,
  CenterViewState,
  PreviewColorList,
  ProductId,
} from "@/js/Const.js";
import { CreateImageElement, CreateFrameCutlineImage, CombineSVGFrame } from "@/js/CommonFunc.js";
import { OffScreen } from "@/js/OffScreen.js";
import { ProductData } from "@/js/ProductData.js";
import VueCookies from "vue-cookies";
import { User } from "@/js/User.js";

export default {
  name: "RightMenuFirstTimeFreeUpload_Ap",
  props: {},
  data: function () {
    return {
      designFileName:"デザインデータ",
      cutlineFileName:"カットラインデータ",
      acrylNum: 1,
      price: 0,       // 割引後の1枚あたりの金額
      discountText: "",
      totalPrice: 0,  // 合計金額（税別）
      selectProductData: null,
      // 配送先
      destinationList: [],
      selectedDestination: "default", // 選択した配送先情報
    };
  },
  watch: {
  },
  computed: {
    isShareCode(){
      return [
        ProductId.S_SHARE, ProductId.M_SHARE, ProductId.L_SHARE
      ].includes(this.$store.state.firstTimeFreeData.selectProductId);
    },
    isUploadDesign() {
      return this.$store.state.firstTimeFreeData.designImageURL != null;
    },
    isUploadCutline() {
      return this.$store.state.commonPreviewData.frameCutlineImageURL != null;
    },
  },
  async created() {
    this.$store.commit("setIsFirstTutorial", false);

    // 販売中のプロダクト情報を取得
    this.$store.commit("showRightMenu");
    this.$store.commit("showLoading");
    await this.$store.state.saleProductManager.update().catch((e) => {
      this.$common.log(e);
      this.$store.commit("hideLoading");
      this.$store.commit("showMessage", "エラーが発生しました");
      this.$store.commit("hideLoading");
      return;
    });

    if (
      this.$store.state.saleProductManager.getProduct(
        this.$store.state.firstTimeFreeData.selectProductId
      ) == null
    ) {
      this.$store.commit("hideLoading");
      this.$store.commit("showMessage", "現在販売されていない商品です");
      this.$store.commit("setCenterViewState", CenterViewState.Upload);
      return;
    }

    this.selectProductData = this.$store.state.saleProductManager.getProduct(
      this.$store.state.firstTimeFreeData.selectProductId
    );

    // 無料キャンペーンなので強制0円
    this.selectProductData.productData["product_class_list2"][0]["price02"] = "0";

    if (this.$store.state.firstTimeFreeData.scCutlineImageURL) {
      // シェアコード入稿の場合はカットラインを調整する
      console.log("createScFrameCutlineImage");
      await this.createScFrameCutlineImage();
    }

    this.$store.commit("hideLoading");

    if( this.isShareCode ){
      // シェアコード入稿
      // SVGチュートリアルをすでに見ている場合は無視
      // let isTutorial = VueCookies.get("t_sp_s") || VueCookies.get("t_p_s");
      // if( !isTutorial ){
      //   this.isFirstTutorial = true;

      //   VueCookies.set("t_sp_s", true);

      //   // チュートリアル開始
      //   this.$store.commit("showPreviewTutorial", 3);
      // }
    }else{
      // SVG入稿
      let isTutorial = VueCookies.get("t_p_s");
      if( !isTutorial ){
        this.$store.commit("setIsFirstTutorial", true);

        VueCookies.set("t_p_s", true, '1y');

        // チュートリアル開始
        this.$store.commit("showPreviewTutorial");
      }
    }

    this.destinationList = await User.getDestinationList().catch((e) => {
      this.$common.log(e);
      this.$store.commit("hideLoading");
      this.tabAction(1);
      this.$store.commit("showMessage", "エラーが発生しました");
    });
  },
  components: {},
  methods: {
    getDesignFileName(){
      return this.designFileName;
    },
    getCutlineFileName(){
      return this.cutlineFileName;
    },
    async uploadDesign() {
      const file = this.$refs.design.files[0];
      this.designFileName = file.name;

      let canvasSize = GetCanvasSize(this.$store.state.firstTimeFreeData.selectProductId);
      let offScreen = new OffScreen(canvasSize.width, canvasSize.height);
      let image = await CreateImageElement(URL.createObjectURL(file));
      offScreen.drawImage(image, 0, 0, image.width, image.height);
      let blob = await new Promise((resolve) => {
        offScreen.toBlob(function (blob) {
          resolve(blob);
        });
      });

      this.$store.commit("setFirstTimeFreeDesignImageFile", blob);
      this.$store.commit("setFirstTimeFreeDesignImageURL", URL.createObjectURL(blob));
      this.$store.commit("setCommonDesignImageURL", URL.createObjectURL(blob));
    },
    async uploadCutline() {
      let file = this.$refs.cutline.files[0];

      // フレームパスを合成
      file = await CombineSVGFrame(file, this.selectProductData.productId);

      this.cutlineFileName = file.name;
      this.$store.commit("setFirstTimeFreeCutlineImageFile", file);
      this.$store.commit("setFirstTimeFreeCutlineImageURL", URL.createObjectURL(file));

      let canvasSize = GetCanvasSize(this.$store.state.firstTimeFreeData.selectProductId);
      const imageWidth = canvasSize.width;
      const imageHeight = canvasSize.height;
      let offScreen = new OffScreen(imageWidth, imageHeight);

      let image = await CreateImageElement(this.$store.state.firstTimeFreeData.cutlineImageURL);
      offScreen.drawImage(image, 0, 0, imageWidth, imageHeight);
      offScreen.replacement(PreviewColorList[this.$store.state.commonPreviewData.selectCutlineColor])

      const blob = await new Promise((resolve) => {
        offScreen.toBlob(function (blob) {
          resolve(blob);
        });
      });

      //this.$store.commit("setFrameCutlineImageFile", blob);
      this.$store.commit("setCommonFrameCutlineImageURL", URL.createObjectURL(blob));
    },

    onClickEditDestination() {
      this.$store.commit("switchShowCart");
      this.$store.commit("setShippingScreenType", "List");
      this.$store.commit("setCenterViewState", CenterViewState.Shipping);
    },

    async createScFrameCutlineImage() {
      let canvasSize = GetCanvasSize(this.$store.state.firstTimeFreeData.selectProductId);
      let blob = await CreateFrameCutlineImage(this.$store.state.firstTimeFreeData.scCutlineImageURL, canvasSize.width, canvasSize.height);
      // this.$store.commit("setFrameCutlineImageURL", URL.createObjectURL(blob));
      // this.$store.commit("setFrameCutlineImageFile", blob);

      // 色も設定する
      const imageWidth = canvasSize.width;
      const imageHeight = canvasSize.height;
      let offScreen = new OffScreen(imageWidth, imageHeight);

      let image = await CreateImageElement(URL.createObjectURL(blob));
      offScreen.drawImage(image, 0, 0, imageWidth, imageHeight);
      offScreen.replacement(PreviewColorList[this.$store.state.commonPreviewData.selectCutlineColor]);

      const blob2 = await new Promise((resolve) => {
        offScreen.toBlob(function (blob2) {
          resolve(blob2);
        });
      });

      this.$store.commit("setCommonFrameCutlineImageURL", URL.createObjectURL(blob2));
    },

    async onClickOrder() {
      if (this.selectedDestination == "default") {
        this.$store.commit("showMessage", "配送先を設定してください");
        return;
      }

      if (!this.$store.state.isSignature) {
        this.$store.commit("showResendContractDialog");
        //this.$store.commit("showMessage", "契約書へのサインが完了していません");
        return;
      }

      // 注文手前までデータを作成し、アンケート画面へ

      // データを作成
      await this.createProduct();

      this.$store.commit("setFirstTimeFreeSelectDestination", this.destinationList[this.selectedDestination]);

      // アンケート画面へ
      this.$store.commit("setCenterViewState", CenterViewState.FirstTimeFreeSurvey);
      this.$store.commit("hideRightMenu");
    },

    async createProduct() {
      let p = new ProductData(
        this.selectProductData,
        this.selectProductData.productData["product_class_list2"][0]
      );

      p.quantity = this.acrylNum;
      p.tagInfo = "noTag";
      p.setPrintInfo("front");
      p.tagTemplateName = "";
      p.whiteCount = 0;
      p.isShareCodeDraft = this.isShareCode;

      //this.$store.commit("hideModal");
      this.$store.commit("selectProduct", p);
      this.$store.commit("selectCanvasData", p.canvasDatas[0]);

      await this.$store.state.currentCanvasData.setBaseImage(
        this.$store.state.firstTimeFreeData.designImageFile,
        this.$store.state.firstTimeFreeData.designImageURL,
        (this.isShareCode)?this.$store.state.firstTimeFreeData.scCutlineImageFile:this.$store.state.firstTimeFreeData.cutlineImageFile,
        this.$store.state.commonPreviewData.frameCutlineImageURL
      );
    },
    clickPngHelp(){
      this.$store.commit("setPreviewTutorialScroll", this.$refs.ScrollRef.scrollTop);
      this.$store.commit("showPreviewTutorial", 1);
    },
    clickSvgHelp(){
      this.$store.commit("setPreviewTutorialScroll", this.$refs.ScrollRef.scrollTop);
      this.$store.commit("showPreviewTutorial", 2);
    },

  },
};
</script>

<style scoped lang="scss">
.uploadlabel {
  margin: 8px;
  padding: 8px;
  cursor: pointer;
  font-size: 15px;
  width: 267px;
  height: 40px;
  color: $primary-main-color;
  border: 2px solid $primary-main-color;
  border-radius: 100px;
  background: $background-white-color;
}

.fill-color {
  fill: $primary-main-color;
  position: absolute;
  left: 51px;
  top: 6px;
}

input[type="file"] {
  display: none;
}

.btn-size{
  width: 100%;
  height: 40px;
  font-weight: bold;
}
.form{
  height: 48px;

}

.forminput {
  width: 100%;
  border: 1px solid $status-success-color;
}

.disable-ui {
  opacity: 0.5;
}

.feature-ui{
  z-index: 3;
  pointer-events: none;
  background: white;
}

.outline-btn {
  width: 250px;
  height: 40px;
  border: 3px solid $primary-main-color;
  color: $primary-main-color;
  border-radius: 20px;
  margin-top: 1px;
  background-color: white;
  font-weight: bold;
}
</style>
